import React from "react";
import { useTranslation } from "react-i18next";

import style from "./buyback-tradein-view.scss";
import { createDateLabel, currency } from "utils/format";

import checkIcon from "assets/images/icons/checkMarkInCircle.svg";
import crossIcon from "assets/images/icons/cross.svg";

interface BuybackDetailBoxProps {
    value: number;
    currencyCode: string;
    eligible: boolean | undefined;
    date: string;
    channel: string;
    tradeId?: string;
    expiration?: string;
    isQuote?: boolean;
}

export default function BuybackDetailBox(props: BuybackDetailBoxProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <div className={style.buyBackView}>
            <div className={style.boxed}>
                <div className={style.label}>{t("DiagnosticReportsTable.buyBackTradeInDetail.value")}</div>
                <div>{currency(props.value, props.currencyCode)}</div>

                <div className={style.label}>{t("DiagnosticReportsTable.buyBackTradeInDetail.eligible")}</div>
                <div>
                    <img src={props.eligible ? checkIcon : crossIcon} alt={props.eligible?.toString()} />
                </div>

                <div className={style.label}>{t("DiagnosticReportsTable.buyBackTradeInDetail.date")}</div>
                <div>{createDateLabel(props.date)}</div>

                {props.isQuote && props.tradeId && (
                    <>
                        <div className={style.label}>{t("DiagnosticReportsTable.buyBackTradeInDetail.tradeId")}</div>
                        <div>{props.tradeId}</div>
                    </>
                )}

                {props.isQuote && props.expiration && (
                    <>
                        <div className={style.label}>
                            {t("DiagnosticReportsTable.buyBackTradeInDetail.offerExpiry")}
                        </div>
                        <div>{createDateLabel(props.expiration)}</div>
                    </>
                )}

                <div className={style.label}>{t("DiagnosticReportsTable.buyBackTradeInDetail.channel")}</div>
                <div>{props.channel}</div>
            </div>
        </div>
    );
}
